// order-toggle
export default function initOrderToggle() {
	$('.order-card').each(function(){
		$(this).find('.order-card__head').on('click', function() {
			$(this).toggleClass('js__open');
			$(this).siblings('.order-card__body').slideToggle();
		});
	});
}